import { Box, Typography } from "@mui/material";

import BszTeacherRow from "./BszTeacherRow";

export default function BszTeacherList({ subject, teachers, getRemaining }) {
  return (
    <Box sx={{ mt: 1 }}>
      <Typography sx={{ fontWeight: 600 }}>{subject}</Typography>

      {teachers.length === 0 ? (
        <Typography sx={{ opacity: 0.6 }}>
          ❌ aktuell niemand verfügbar
        </Typography>
      ) : (
        teachers.map((teacher, index) => (
          <BszTeacherRow
            key={index}
            teacher={teacher}
            remaining={getRemaining(teacher.endTime)}
          />
        ))
      )}
    </Box>
  );
}
